const initialState = {
  open: false,
};

const publishMsg = (state = initialState, action) => {
  switch (action.type) {
    case 'TOGGLE_PUBLISH_MSG':
      return {
        ...state,
        open: action.data,
      };
    case 'LOGOUT_SUCCESS':
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default publishMsg;
